/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Pillar_EyebrowInputs */

const es_cap_pillar_eyebrow = /** @type {(inputs: Cap_Pillar_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por qué patronear con Zarpar`)
};

const gl_cap_pillar_eyebrow = /** @type {(inputs: Cap_Pillar_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que patronear con Zarpar`)
};

const en_cap_pillar_eyebrow = /** @type {(inputs: Cap_Pillar_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why skipper with Zarpar`)
};

/**
* | output |
* | --- |
* | "Why skipper with Zarpar" |
*
* @param {Cap_Pillar_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_pillar_eyebrow = /** @type {((inputs?: Cap_Pillar_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Pillar_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_pillar_eyebrow(inputs)
	if (locale === "en") return en_cap_pillar_eyebrow(inputs)
	return es_cap_pillar_eyebrow(inputs)
});